/**
 * Transform booking parts into a a group of ticket download for accommodations.
 * 1 group = 1 accommodation with room vouchers for each room
 */
export function transformTicketGroupsAccommodation(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']) {
    const apiBooking = response?.booking;
    if (!apiBooking) {
        return [];
    }

    return bookingParts
        .filter(bp => bp.objectType === 'Accommodation')
        .reduce<TicketGroupAccommodation[]>((list, bookingPart) => {
            assignAccommodation(list, bookingPart, apiBooking);
            return list;
        }, []);
}

/**
 * Assign an accommodation room voucher to the group, if it matches the same accommodation
 */
function assignAccommodation(
    list: TicketGroupAccommodation[],
    accommodation: ApiSchema['Accommodation'],
    apiBooking: ApiSchema['Booking'],
) {
    const type = 'Accommodation';
    const id = accommodation.accommodationDetails?.id ?? '';
    const ticket = transformTicketAccommodation(accommodation, apiBooking);

    let ticketGroup = list
        .filter(p => p.type === type)
        .find(p => p.id === id);
    if (!ticketGroup) {
        ticketGroup = {
            id,
            type,
            tickets: [],
        } satisfies TicketGroupAccommodation;
        list.push(ticketGroup);
    }

    ticketGroup.tickets.push(ticket);
}
